module.exports = __webpack_public_path__ + "img/image.8465385e.png";